import {styled} from '@mui/material';
import type {MenuListProps as MuiMenuListProps} from '@mui/material/MenuList';
import MuiMenuList from '@mui/material/MenuList';
import {excludeComponentProps} from '../utils/excludeComponentProps';

export interface MenuListProps extends MuiMenuListProps {
    hasDivider?: boolean;
}

// Figma Specs
const menuMinWidth = '10rem'; // 160px
const menuMaxWidth = '18.75rem'; // 18.75rem

export const MenuList = styled(MuiMenuList,
    excludeComponentProps('hasDivider')
)<MenuListProps>(({
    theme, hasDivider
}) => ({
    minWidth: menuMinWidth, // 160px
    maxWidth: menuMaxWidth, // 300px
    backgroundColor: theme.tokens.FuelColorWhite,
    flex: 'none',
    zIndex: 2,
    ...hasDivider && {
        '& .MenuItem-root': {
            borderBottom: `solid 1px ${theme.tokens.FuelColorGray300}`,
            '&:last-of-type': {
                'border-bottom': 'none'
            }
        }
    }
}));
